<template>
    <div class="flex flex-column items-center justify-center error-layout">
        <h1 class="error-layout__number">
            {{ error.statusCode }}
        </h1>
        <nuxt-img
            src="error/lines.svg"
            alt="lines"
            format="webp"
            quality="100"
            class="error-layout__image"
        />
        <p class="error-layout__heading">
            Что-то пошло не так
        </p>
        <p
            v-if="error.statusCode === 404"
            class="error-layout__text"
        >
            Страница, которую вы запрашиваете не существует.
            Возможно она устарела, была удалена или вы ввели неверный адрес.
        </p>
        <UILink
            to="/"
            class="error-layout__button"
            label="перейти на главную"
            link-color="#fff"
        />
    </div>
</template>

<script>
import {defineComponent, onMounted, useContext} from '@nuxtjs/composition-api';
import {UILink} from '@cibsite/ui-components-vue2';

export default defineComponent({
    name: 'ErrorLayout',
    components: {
        UILink,
    },
    layout: 'empty',
    props: {
        error: {
            type: Object,
            required: true,
        },
    },
    setup(props) {
        const {$ym} = useContext();

        onMounted(() => {
            if (String(props.error?.statusCode).startsWith('5')) {
                $ym('catch500Error');
            }
        });
    },
});
</script>

<style lang="scss">
    @import '@/assets/styles/pages/error';
</style>
